import {Box, IconButton, Typography} from '@mui/material'
import React, {useState} from 'react'
import {WidgetCard} from './WidgetCard'
import {RecurrenceDialog} from '../../dialogs/recurrence/RecurrenceDialog'
import {Recurrence} from '../../../domain/Recurrence'
import {formatMonthAndYear} from '../../../utils/formatValuesUtils'
import {Month} from '../../../domain/Month'
import OpenDialogIcon from '@mui/icons-material/LaunchRounded'
import {useTheme} from '@mui/material'
import {useIsMobile} from '../../../utils/useIsMobile'

type WidgetPanelProps = {
  recurrences: Recurrence[],
  currentBalance: string,
  handleRecurrencesUpdate: (recurrences: Recurrence[]) => void,
  firstNegativeBalanceMonth: Month | null,
}

const WidgetPanel: React.FC<WidgetPanelProps> = ({recurrences, currentBalance, handleRecurrencesUpdate, firstNegativeBalanceMonth}) => {
  const theme = useTheme()
  const isMobile = useIsMobile()
  const [isRecurrenceDialogOpen, setIsRecurrenceDialogOpen] = useState(false)
  const isProjectedBalanceNegative = !!firstNegativeBalanceMonth

  return (
    <Box sx={{top: '64px', zIndex: 1000, backgroundColor: 'white', paddingTop: 1}}>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: {xs: '1fr 1fr', md: 'repeat(6, 1fr)'},
        gap: 1,
        minHeight: '100px',
        paddingBottom: 2,
      }}>
        <WidgetCard title="Récurrences" themeColor={theme.palette.recurrence} onClick={() => setIsRecurrenceDialogOpen(true)}>
          <IconButton color="recurrence"><OpenDialogIcon/></IconButton>
        </WidgetCard>

        <WidgetCard title="Solde" themeColor={theme.palette.currentBalance} onClick={() => {}}>
          <Typography variant="h5" sx={{fontWeight: 'bold'}}>{`${currentBalance} €`}</Typography>
        </WidgetCard>

        <WidgetCard
          title={`Prévisionnel: ${isProjectedBalanceNegative ? 'Découvert' : 'OK'}`}
          themeColor={isProjectedBalanceNegative ? theme.palette.negativeProjectedBalance : theme.palette.positiveProjectedBalance}
          onClick={() => {}}
        >
          {isProjectedBalanceNegative
            ? <Typography variant="h6">{formatMonthAndYear(firstNegativeBalanceMonth!.month, firstNegativeBalanceMonth!.year)}</Typography>
            : null}
        </WidgetCard>

        {!isMobile && (
          <>
            <WidgetCard title="Épargne" themeColor={theme.palette.disabled} onClick={() => {}} disabled/>
            <WidgetCard title="Remboursement" themeColor={theme.palette.disabled} onClick={() => {}} disabled/>
            <WidgetCard title="Historique" themeColor={theme.palette.disabled} onClick={() => {}} disabled/>
          </>
        )}
      </Box>

      <RecurrenceDialog
        isOpen={isRecurrenceDialogOpen}
        onClose={() => setIsRecurrenceDialogOpen(false)}
        recurrences={recurrences}
        handleRecurrencesUpdate={handleRecurrencesUpdate}
      />
    </Box>
  )
}

export default WidgetPanel